import React, { useState } from "react";
import {
  Form,
  Button,
  Col,
  Row,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { BsArrowRightShort } from "react-icons/bs";
import { toast } from "react-toastify";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

import {
  onChangePreferenceForProduct,
  onChangePreferenceForSearchParameters,
  setIsInvoiceSyncRulesSaved,
  onChangeStripeProductMetadataPreference,
} from "../../store/slice/invoiceSlice";
import { getUrl } from "../../helpers/url";

import { useCmsHook } from "../../helpers/cms/cmsHook";

import FieldsDropdown from "../FieldsDropdown";
import MappingWindow from "../mapping/MappingWindow";

function SyncRules() {
  const { cmsInstance } = useCmsHook();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const {
    preferenceForProduct,
    productPreference,
    preferenceForSearchParameters,
    stripeProductSearchParameter,
    msbcProductSearchParameter,
    stripeProductMetadataPreference,
    invoiceTriggerFields,
    invoiceTriggerPreference,
  } = useSelector((state) => state.invoice);
  // mappings states
  const {
    mappings: {
      mappings: { product: mappings },
    },
    stripe: {
      stripeDropdownFields: {
        product: stripeFields,
        productsSearchFields: stripeProductFields,
      },
      loading: stripeLoading,
    },
    msbc: {
      msbcDropdownFields: {
        // invoice: msbcInvoiceFields,
        product: msbcFields,
        productsSearchFields: msbcProductFields,
      },
      loading: msbcLoading,
    },
    isMappingsSaved: { product: isMappingsSaved },
  } = useSelector((state) => state.mapping);
  const [isLoading, setIsLoading] = useState(false);

  const renderText = () => {
    if (stripeFields.length === 0 && msbcFields.length === 0) {
      return "Products not found in both Stripe and Business Central";
    } else if (stripeFields.length === 0) {
      return "Products not found in Stripe";
    } else if (msbcFields.length === 0) {
      return "Products not found in Business Central";
    }
  };

  return (
    <div>
      <hr className="settings-horizontal-line" />

      {stripeLoading || msbcLoading ? (
        <div
          className="d-flex flex-row justify-content-center align-items-center my-3"
          style={{ height: "40vh" }}
        >
          <Spinner
            animation="border"
            variant="secondary"
            role="status"
            size="md"
          ></Spinner>
        </div>
      ) : (
        <div>
          <div>
            {cmsInstance &&
              cmsInstance.showRichText(
                "cmsContent.invoice.syncRules.section1.description",
                "rules-description"
              )}

            <Form.Check
              key="selectSearchParameters"
              id="selectSearchParameters"
              type="radio"
              name="productSearchParameters"
              label="Select search parameters"
              value="Select search parameters"
              className="mb-3 sync-radio-buttons"
              checked={
                preferenceForSearchParameters === "Select search parameters"
              }
              onChange={(e) =>
                dispatch(
                  onChangePreferenceForSearchParameters({
                    preference: e.target.value,
                  })
                )
              }
            />

            {preferenceForSearchParameters === "Select search parameters" && (
              <>
                {stripeProductFields &&
                  stripeProductFields.length > 0 &&
                  msbcProductFields &&
                  msbcProductFields.length > 0 && (
                    <div className="ms-3">
                      {cmsInstance &&
                        cmsInstance.showRichText(
                          "cmsContent.invoice.syncRules.section1.searchParameter",
                          "rules-description"
                        )}
                      <Row className="mb-4">
                        <Col sm={5} lg={3}>
                          <span className="rules-sub-headings mb-2">
                            Stripe
                          </span>
                          <FieldsDropdown
                            fieldsData={stripeProductFields}
                            dropdownFor={"stripeProductSearchParameter"}
                            selectedPreference={stripeProductSearchParameter}
                          />
                        </Col>
                        <Col
                          sm={1}
                          className="px-0 d-flex flex-row justify-content-center mb-1"
                          style={{ maxWidth: "40px" }}
                        >
                          <span></span>
                          <BsArrowRightShort className="mt-auto" size={25} />
                        </Col>
                        <Col sm={5} lg={3}>
                          <span className="rules-sub-headings mb-2">
                            Business Central
                          </span>
                          <FieldsDropdown
                            fieldsData={msbcProductFields}
                            dropdownFor={"msbcProductSearchParameter"}
                            selectedPreference={msbcProductSearchParameter}
                          />
                        </Col>
                      </Row>

                      {stripeProductSearchParameter &&
                        stripeProductSearchParameter.value === "key" && (
                          <Col sm={5} lg={2} className="mb-3 ms-3">
                            <Form.Control
                              type="text"
                              placeholder="Metadata"
                              className="meta-data-text-box ms-1"
                              value={stripeProductMetadataPreference}
                              onChange={(e) =>
                                dispatch(
                                  onChangeStripeProductMetadataPreference({
                                    enteredInput: e.target.value,
                                  })
                                )
                              }
                            />
                          </Col>
                        )}
                    </div>
                  )}
              </>
            )}

            <Form.Check
              key="setCustomMappings"
              id="setCustomMappings"
              type="radio"
              name="productSearchParameters"
              label="Set custom mappings"
              value="Set custom mappings"
              className="mb-3 sync-radio-buttons"
              checked={preferenceForSearchParameters === "Set custom mappings"}
              onChange={(e) =>
                dispatch(
                  onChangePreferenceForSearchParameters({
                    preference: e.target.value,
                  })
                )
              }
            />

            {preferenceForSearchParameters === "Set custom mappings" && (
              <>
                {stripeFields &&
                stripeFields.length > 0 &&
                msbcFields &&
                msbcFields.length > 0 ? (
                  <div className="ms-3">
                    <MappingWindow
                      mappings={mappings}
                      stripeFields={stripeFields}
                      msbcFields={msbcFields}
                      mappingsFor={"product"}
                      pathName="cmsContent.invoice.syncRules.section1.mappingHeader"
                      notificationPath="productFieldMappings"
                    />
                  </div>
                ) : (
                  <Row className="search-results-not-found-container ms-4 my-3 py-3">
                    <Col className="d-flex flex-column justify-content-center align-items-center px-0">
                      <p
                        className="search-results-text my-0"
                        style={{ fontSize: "14px" }}
                      >
                        {renderText()}
                      </p>
                    </Col>
                  </Row>
                )}
              </>
            )}
          </div>

          <hr className="settings-horizontal-line" />

          <div>
            {cmsInstance &&
              cmsInstance.showRichText(
                "cmsContent.invoice.syncRules.section2.description",
                "rules-description"
              )}
            <div>
              <Form.Check
                key="doNotGenerateInvoice"
                type="radio"
                id="doNotGenerateInvoice"
                name="productRadioButtons"
                value="Do not generate invoice"
                label="Do not generate invoice"
                className="mb-3 sync-radio-buttons"
                checked={preferenceForProduct === "Do not generate invoice"}
                onChange={(e) =>
                  dispatch(
                    onChangePreferenceForProduct({
                      preference: e.target.value,
                    })
                  )
                }
              />

              {preferenceForProduct === "Do not generate invoice" && (
                <>
                  <Row className="ms-3">
                    {cmsInstance &&
                      cmsInstance.showRichText(
                        "cmsContent.invoice.syncRules.section2.donNotGenerateInvoice",
                        "oauth-card-para"
                      )}
                  </Row>
                </>
              )}

              <Form.Check
                key="useDefaultProduct"
                type="radio"
                id="useDefaultProduct"
                name="productRadioButtons"
                value="Use default product"
                label="Use default product"
                className="mb-3 sync-radio-buttons"
                checked={preferenceForProduct === "Use default product"}
                onChange={(e) =>
                  dispatch(
                    onChangePreferenceForProduct({
                      preference: e.target.value,
                    })
                  )
                }
              />

              {preferenceForProduct === "Use default product" && (
                <>
                  {msbcFields && msbcFields.length > 0 ? (
                    <Row className="mt-3 ms-3">
                      {cmsInstance &&
                        cmsInstance.showRichText(
                          "cmsContent.invoice.syncRules.section2.defaultProduct",
                          "oauth-card-para"
                        )}
                      <Col sm={5} lg={3}>
                        <span className="rules-sub-headings mb-2">
                          Select Product
                        </span>
                        <FieldsDropdown
                          fieldsData={msbcFields}
                          dropdownFor={"invoiceProduct"}
                          selectedPreference={productPreference}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <Row className="search-results-not-found-container ms-4 my-3 py-3">
                      <Col className="d-flex flex-column justify-content-center align-items-center px-0">
                        <p
                          className="search-results-text my-0"
                          style={{ fontSize: "14px" }}
                        >
                          No products present in Business Central
                        </p>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </div>
          </div>

          <hr className="settings-horizontal-line" />

          <div className="mt-3 py-2">
            {cmsInstance &&
              cmsInstance.showRichText(
                "cmsContent.invoice.syncRules.section3",
                "rules-description"
              )}
            {invoiceTriggerFields && invoiceTriggerFields.length > 0 && (
              <Col sm={5} lg={3}>
                <FieldsDropdown
                  fieldsData={invoiceTriggerFields}
                  dropdownFor="invoiceTrigger"
                  selectedPreference={invoiceTriggerPreference}
                />
              </Col>
            )}
          </div>

          {/* <hr className="mt-3 py-2" />

          <div>
            {cmsInstance &&
              cmsInstance.showRichText(
                "cmsContent.invoice.syncRules.section4",
                "rules-description"
              )}
            {dealStageFields && dealStageFields.length > 0 && (
              <Col sm={5} lg={3}>
                <FieldsDropdown
                  fieldsData={dealStageFields}
                  dropdownFor="dealStage"
                  selectedPreference={dealStagePreference}
                />
              </Col>
            )}
          </div> */}

          <div className="save-button-container mt-5">
            {(preferenceForSearchParameters === "Set custom mappings" &&
              (checkCountForProductMapped({ mappings: mappings }) === 0 ||
                (checkCountForProductMapped({ mappings: mappings }) > 0 &&
                  !isMappingsSaved))) ||
            (preferenceForSearchParameters === "Select search parameters" &&
              (!stripeProductSearchParameter || !msbcProductSearchParameter)) ||
            (preferenceForProduct === "Use default product" &&
              !productPreference) ||
            (stripeProductSearchParameter &&
              stripeProductSearchParameter.value === "key" &&
              !stripeProductMetadataPreference) ||
            !invoiceTriggerPreference ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip style={{ fontSize: "11px" }}>
                    {showToolTipText(
                      preferenceForProduct,
                      productPreference,
                      preferenceForSearchParameters,
                      stripeProductSearchParameter,
                      msbcProductSearchParameter,
                      isMappingsSaved,
                      stripeProductMetadataPreference,
                      mappings,
                      invoiceTriggerPreference
                    )}
                  </Tooltip>
                }
              >
                <Button
                  className="save-changes-button"
                  style={{ opacity: "0.9", cursor: "not-allowed" }}
                >
                  Save
                </Button>
              </OverlayTrigger>
            ) : (
              <Button
                className="save-changes-button"
                onClick={() =>
                  onSaveInvoiceSyncRules({
                    setIsLoading,
                    searchParams,
                    preferenceForProduct,
                    productPreference,
                    stripeProductSearchParameter,
                    msbcProductSearchParameter,
                    stripeProductMetadataPreference,
                    preferenceForSearchParameters,
                    dispatch,
                    invoiceTriggerPreference,
                    cmsInstance,
                  })
                }
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <span>Save</span>
                )}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SyncRules;

/**
 * This function is responsible for getting the count of products mapped
 * @returns {Number} count of products mapped
 */
export const checkCountForProductMapped = ({ mappings }) => {
  let count = 0;
  mappings.forEach((mappedItem) => {
    if (mappedItem.Stripe_FieldName_CRF) {
      count += 1;
    }
  });
  return count;
};

/**
 * This function is used for saving invoice sync rules
 */
export async function onSaveInvoiceSyncRules({
  setIsLoading,
  searchParams,
  preferenceForProduct,
  productPreference,
  stripeProductSearchParameter,
  msbcProductSearchParameter,
  stripeProductMetadataPreference,
  preferenceForSearchParameters,
  dispatch,
  invoiceTriggerPreference,
  cmsInstance,
}) {
  try {
    setIsLoading(true);
    const account = searchParams.get("account");
    await axios.post(getUrl("REACT_APP_SAVE_PREFERENCES"), {
      account,
      preferences: {
        product: {
          generateInvoice: {
            create:
              preferenceForProduct === "Use default product" ? true : false,
            mapping: {
              msbcDefaultProduct: productPreference,
            },
          },
          filterOptions: {
            filterStripeProperty:
              stripeProductSearchParameter.value === "key"
                ? {
                    name: stripeProductSearchParameter.name,
                    value: stripeProductMetadataPreference,
                  }
                : stripeProductSearchParameter,
            filterMsbcProperty: msbcProductSearchParameter,
          },
          searchParameters:
            preferenceForSearchParameters === "Select search parameters"
              ? false
              : true,
        },
        invoice: {
          triggerSettings: {
            invoiceStage: invoiceTriggerPreference,
          },
          // actionSettings: {
          //   dealStage: dealStagePreference,
          // },
        },
      },
      preferenceType: "invoice",
    });
    dispatch(setIsInvoiceSyncRulesSaved());
    toast.success(
      cmsInstance &&
        cmsInstance.sendData().cmsContent.notifications.syncSettings
          .successContent.invoiceSyncRules.message
    );
  } catch (error) {
    console.log(error);
    let errorMessage;
    if (error.response && error.response.data.message)
      errorMessage = error.response.data.message;
    else errorMessage = error.message;
    toast.error(errorMessage);
  } finally {
    setIsLoading(false);
  }
}

/**
 * This function is used for showing custom message in Tooltip for save button
 * @param {String} preferenceForProduct selected option from radio buttons
 * @param {Object} productPreference selected product
 * @returns {String} custom message
 */
const showToolTipText = (
  preferenceForProduct,
  productPreference,
  preferenceForSearchParameters,
  stripeProductSearchParameter,
  msbcProductSearchParameter,
  isMappingsSaved,
  stripeProductMetadataPreference,
  mappings,
  invoiceTriggerPreference
) => {
  if (!invoiceTriggerPreference) {
    return "Please select trigger for invoice";
  } else if (
    preferenceForProduct === "Use default product" &&
    !productPreference
  ) {
    return "please select the product";
  } else if (
    preferenceForSearchParameters === "Select search parameters" &&
    !stripeProductSearchParameter
  ) {
    return "Please select stripe search parameter";
  } else if (
    preferenceForSearchParameters === "Select search parameters" &&
    !msbcProductSearchParameter
  ) {
    return "Please select Business Central search parameter";
  } else if (
    preferenceForSearchParameters === "Set custom mappings" &&
    checkCountForProductMapped({ mappings: mappings }) === 0
  ) {
    return "Please map at least one product from the mapping window to proceed further";
  } else if (
    preferenceForSearchParameters === "Set custom mappings" &&
    checkCountForProductMapped({ mappings: mappings }) > 0 &&
    !isMappingsSaved
  ) {
    return "Please save the product mappings.";
  } else if (
    stripeProductSearchParameter &&
    stripeProductSearchParameter.value === "key" &&
    !stripeProductMetadataPreference
  ) {
    return "Metadata is empty. Please enter a valid metadata.";
  }
};
